import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../shared/common.service'; 
import { LoginLayoutService } from '../../layouts/login-layout/login-layout.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  submitted = false;
    userId: string = '';
    passwordFieldType: string = 'password';
    password: string = 'password';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public commonService: CommonService,
    public loginLayoutService: LoginLayoutService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.userId = params['userId']; 
    });

    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, { validator: this.passwordMatchValidator });
  }

  get f() {
    return this.resetPasswordForm.controls;
  }

  passwordMatchValidator(form: FormGroup) {
    return form.get('password')?.value === form.get('confirmPassword')?.value
      ? null : { mismatch: true };
  }

  onSubmit() {
    this.submitted = true;
  
    if (this.resetPasswordForm.invalid) {
      return;
    }
  
    const resetData = {
      userId: this.userId,
      password: this.resetPasswordForm.value.password
    };
  
    this.loginLayoutService.resetPassword(resetData).subscribe(
      (Response: any) => {
        if (Response.code === 1) {
          this.commonService.notifier.notify('success', 'Password reset successfully.');
          this.router.navigate(['/login']);
        } else {
          this.commonService.notifier.notify('error', Response.message);
        }
      },
      (error) => {
        // console.log('API Error:', error); 
        this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
      }
    );
    }

    togglePasswordVisibility(): void {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
       
    }

    togglePasswordVisibility1(): void {
        this.password = this.password === 'password' ? 'text' : 'password';
    }

}
